import { FormProvider } from "react-hook-form";
import { Button } from "@/components/ui/button";
import { CheckIcon } from "@heroicons/react/16/solid";
import { ExceptionsList } from "./exceptions-list";

export const ExceptionsForm = ({
    methods,
    onSubmit,
    exceptions,
    isPending,
}) => {
    return (
        <FormProvider {...methods}>
            <form
                onSubmit={methods.handleSubmit(onSubmit)}
                className="col-span-full grid h-full flex-1 grid-cols-subgrid"
            >
                <ExceptionsList exceptions={exceptions} />
                <div className="mt-auto">
                    <Button
                        type="submit"
                        variant="primary"
                        className="mt-4"
                        disabled={isPending}
                    >
                        <CheckIcon />
                        {isPending ? "Saving" : "Save time off"}
                    </Button>
                </div>
            </form>
        </FormProvider>
    );
};
